import clone from 'lodash/clone';
import _keys from 'lodash/keys';
import moment from 'moment';

import Backbone from 'backbone';

import allUsersStore from 'zoomforth_zf/appglobals/all-users.js';

import { displayFixedErrorAlertForXhrFail } from 'zoomforth_tools/modern_helpers.js';

const MediaLibraryAsset = Backbone.Model.extend({
    urlRoot: '/api/assets', 
    
    initialize: function(attrs, options) {
      this.hasChangedSinceSync = false;
      this.on('error', function(model, xhr, options){
        displayFixedErrorAlertForXhrFail(xhr);
      });
      this.listenTo(this, 'sync', function() {
        this.hasChangedSinceSync = false;
        return;
      });
      
      this.listenTo(this, 'change', function(){
        if (_keys(this.changed).length == 1 && (this.changed.renderedCaption)){
          // sometimes rendered caption will insert non breaking spaces -- this
          // does not count as a real change
          return;
        }
        this.hasChangedSinceSync = true;
      });
    }, 
    
    parse: function(data) {
      var clonedData = clone(data);
      clonedData.assetId = clonedData.id;
      clonedData.id = clonedData.assetType + '-' + clonedData.id;
      return clonedData;
    },
    
    isPlayable: function(){
      return this.get('assetType') == 'video' || this.get('assetType') == 'youtube';
    },
    
    isPDF: function(){
      return this.get('assetType') == 'pdf';
    },

    isPPT: function(){
      return this.get('assetType') == 'ppt';
    },

    isHtmlPackage: function(){
      return this.get('assetType') == 'html_package';
    },
    
    isOther: function(){
      return this.get('assetType') == 'other';
    },

    getName: function() {
      return this.get('display_filename');
    },
    
    getFolderId: function(){
      return this.get('parent_folder_id');
    },
    
    moveToFolder: function(folderId){
      return this.save(
        {parent_folder_id: folderId}, 
        {patch: true}
      );
    }, 
    
    getItemType: function() {
      return "asset";
    },

    getDownloadUrl() {
      const assetType = this.get('assetType');
      if (assetType === 'youtube') {
        return null;
      }
      return `/api/assets/download/${this.id}`;
    },

    /*
      Return moment() object with UTC time of last modified date time for this asset
    */
    getLastModifiedAt() {
      return moment(this.get('last_modified_at'));
    },

    /*
      Return moment() object with UTC time of the creation date time for this asset
    */    
    getCreatedAt() {
      return moment(this.get('created_at'));
    },
    
    getUploadedBy: function() {
      var uploaderId = this.get("uploaded_by");
      return allUsersStore.get().getNameById(uploaderId);
    },
    
    getDescription: function() {
      return this.get('rendered_caption');
    },

    getAltText: function() {
      return this.get('default_alt_text');
    },
    
    getUploadPerson: function(){
      var uploadPerson = this.getUploadedBy();
      if(!uploadPerson){
        if(this.get('submitterName')){
          uploadPerson = '' + this.get('submitterName');
        }
        if(this.get('submitterEmail')){
          if(uploadPerson){
            uploadPerson += ' <' + this.get('submitterEmail') + '>';
          } else{
            uploadPerson = '' + this.get('submitterEmail');
          }
          
        }

      }
      return uploadPerson;
    }, 
    
    // This is substantially similar to a function on the page content item model
    // but it must be so, since lens content objects don't have asset models. Alas and alack. 
    getEmbeddedVideoParams: function($container, autoplay) {
      if(this.get('youtubeId')) {
        return {
          container: $container,
          youtubeId: this.get('youtubeId'),
          posterImage: this.get('displayImage'),
          subtitleTrack: this.get('subtitles'),
          autoplay: autoplay
        };
      } else {
        return {
          container: $container,
          mpeg4Source: this.get('streams').mpeg4,
          mpeg4LowQualitySource: this.get('streams').lowQuality,
          subtitleTrack: this.get('subtitles'),
          posterImage: this.get('displayImage'),
          autoplay: autoplay
        };
      }
    },

    // Unfortunately we need to handle asset behaviors in this special way
    // this code was largely extracted from the zf.models.Video asset model, 
    // which has been deprecated.
    //
    saveVideoThumbnail: function(displayImage) {

      if (this.get('assetType') !== 'video') {
        throw new Error('Can\'t save display image for non-video assets');
      }

      var data = { 
        display_image: displayImage,
        // We want `{id}` from the `{type}-{id}` ident string
        // e.g., "56" not "video-56"
        video_id: this.get('assetId') 
      };

      return $.ajax({
        url : '/video/edit',
        data : data,
        type: 'post',
        dataType: 'json',
        error: displayFixedErrorAlertForXhrFail
      });

    },

    
    rename: function(new_name) {
      return this.save(
        {name: new_name},
        {patch: true}
      );
    }

  }, {
    
    fancyboxSettings: function(youtubeId, caption){
      // WILCOX: Good god, lemon! Who the fuck named this method?
      var fancyboxSettings = {
        href : 'https://www.youtube.com/embed/'+youtubeId,
        type: 'iframe',
        maxWidth : '100%',
        maxHeight : '100%',
        height: '70%',
        width: '70%',
        fitToView : false,
        openEffect : 'none',
        closeEffect : 'none'
      };
      if (caption){
        fancyboxSettings['title'] = caption;
      }
      return fancyboxSettings;
    },
    
    // KOTZ TODO -- Obviously this should use the asset api to create this asset, but for the sake
    // of getting rid of the photo model I'll do this for right now and clean it up at the same time
    // as the other "create" cleanup I have marked with a todo somewhere. 
    createPhoto: function(data){
      //create an asset from a target url
      return $.ajax({
        url : '/photo/create',
        type: 'post',
        data: data,
        dataType: 'json',
        error: displayFixedErrorAlertForXhrFail
      });
    
    } 
  });
  
export default MediaLibraryAsset;
